<mat-toolbar>
  <button id="btn-menu" mat-icon-button (click)="sidenav.toggle()">
    <span class="material-icons"> menu </span>
  </button>

  <div id="titleName">
    <h2>Mi cuenta</h2>
    <p>¡Hola! {{firebaseAuthService.publicUser.displayName}}</p>
  </div>
</mat-toolbar>

<mat-drawer-container class="example-container" [hasBackdrop]="diviceXs || diviceSm">

  <mat-drawer [mode]="!diviceXs && !diviceSm ? 'side' : 'over'" [opened]="!diviceXs && !diviceSm" #sidenav>
    <app-slider-menu></app-slider-menu>
  </mat-drawer>

  <mat-drawer-content>

    <div id="purchases">

      <h1>Compras</h1>

      <section>
        <ng-container *ngFor="let order of orderList">

          <mat-card fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around center">

            <div id="dataAndNumOrder" fxFlex="30" fxFlex.xs="90">
              <h4>
                <strong>Código de orden:</strong>
                <span>{{order.id | shortOrderCode }}</span>
                <!-- <span>{{order.numberOfOrder}}</span> -->
              </h4>
              <p>
                <strong>Compra realizada el:</strong>
                <span>{{ order.date.seconds *1000| date: 'dd-MM-yyyy'}}</span>
                <!-- <span>{{order.purchaseDate}}</span> -->
              </p>

            </div>

            <div id="orderSummary" fxFlex="50" fxFlex.xs="90">
              <h2>Resumen de compra</h2>

              <!-- <ng-container *ngIf="!order.paidWithPoints else paidWithPoints"> -->
              <ng-container *ngIf="!false else paidWithPoints">

                <div id="contentPaidWithMoney">
                  <h3 fxLayout="row" fxLayoutAlign="start center" fxLayoutAlign.xs="center center">
                    <span class="material-icons-outlined">paid</span>
                    <span> Pago con dinero</span>
                  </h3>

                  <p><strong>Total {{order.orderDetail.length >= 2 ? 'productos' : 'producto'}}:</strong>
                    <!-- <p><strong>Total {{order.products.length >= 2 ? 'productos' : 'producto'}}:</strong> -->
                    {{order.total | currency:'COP '}}</p>
                  <p><strong>Medio de pago:</strong> {{order.paymentMethod}}</p>
                  <!-- <p id="accumulatedPoints"><strong>Puntos acumulados:</strong> {{order.pointsGenerated}} Gessis</p> -->
                  <p id="accumulatedPoints"><strong>Estatus de la orden: </strong> {{order.orderStatus}}</p>
                </div>

              </ng-container>

              <ng-template #paidWithPoints>

                <div id="contentPaidWithPoints">

                  <h3 fxLayout="row" fxLayoutAlign="start center" fxLayoutAlign.xs="center center">
                    <span id="ic-pointsGessi"></span>
                    <span>Pago con puntos</span>
                  </h3>
                  <!-- <p><strong>Total:</strong> {{order.totalPoints}} Gessis</p> -->
                  <p><strong>Total:</strong>Gessis</p>

                </div>

              </ng-template>

              <hr />

              <ng-container *ngIf="true else shippingCost">
                <!-- <ng-container *ngIf="order.freeShipping else shippingCost"> -->
                <h4 id="freeShipping">Envio Gratis</h4>
              </ng-container>

              <ng-template #shippingCost>
                <!-- <p id="shippingCost"><strong>Costo de envio:</strong> {{order.costOfShipping | currency:'COP '}}</p> -->
                <p id="shippingCost"><strong>Costo de envio:</strong> {{000 | currency:'COP '}}</p>
              </ng-template>
            </div>

            <div id="actions" fxFlex="20" fxFlex.xs="90">
              <button (click)="goToDetails(order)" mat-raised-button color="primary" fxLayout="row"
                fxLayoutAlign="space-evenly center">
                <span class="material-icons"> open_in_new </span>
                <span> Ver detalle </span>
              </button>

              <button mat-raised-button color="primary" (click)="goToHelp(order.id)" fxLayout="row"
                fxLayoutAlign="space-evenly center" disabled="true">

                <span class="material-icons"> contact_support </span>
                <span>Necesito ayuda</span>
              </button>
            </div>
          </mat-card>

        </ng-container>
      </section>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
